import React, {useState} from "react";
import PropTypes from "prop-types";


import {Popover} from "@mui/material";
import {StaticDatePicker} from "@mui/x-date-pickers";
import {startOfMonth} from "date-fns";

import {usePlanner} from ".";

import IconButton from "@mui/material/IconButton";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import './planner.css'


const MonthSelector = (props) => {
    const {visibleDate, renderButton} = props
    const {minDate, maxDate, goToDate} = usePlanner();

    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMonthSelection = (date) => {
        handleClose();
        goToDate(startOfMonth(date));
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return <>
        {!!renderButton ?
            renderButton({'aria-describedby': 'month-picker', onClick: handleClick})
            :
            <IconButton aria-describedby='month-picker' sx={{padding: 0.5}} onClick={handleClick}>
                <CalendarTodayIcon fontSize='small'/>
            </IconButton>
        }

        <Popover
            id='month-picker'
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}>
            <StaticDatePicker defaultValue={visibleDate || new Date()}
                              openTo="year"
                              minDate={minDate}
                              maxDate={maxDate}
                              onMonthChange={handleMonthSelection}
                              views={['year', 'month']}
                              displayStaticWrapperAs="desktop"/>
        </Popover>
    </>
}

MonthSelector.propTypes = {
    visibleDate: PropTypes.instanceOf(Date),
    renderButton: PropTypes.func
}

export default MonthSelector;